document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("gallery-slider")) {
    customElements.define(
      "gallery-slider",
      class GallerySlider extends HTMLElement {
        constructor() {
          super();
          this.sliderRef = this.querySelector("[data-slider]");
          this.nextRef = this.querySelector('[data-navigation="next"]') || null;
          this.previousRef =
            this.querySelector('[data-navigation="previous"]') || null;
          this.productsToShow = this.dataset.productsToShow;
          this.initSwiper = this.initSwiper.bind(this);
          this.childElements = this.querySelectorAll(".swiper-slide");
        }

        connectedCallback() {
          if (!this.sliderRef) {
            return;
          }
          if (
            this.childElements.length < 4 ||
            this.childElements.length < this.productsToShow
          ) {
            return;
          }
          this.initSwiper();
        }

        initSwiper() {
          const slider = new Swiper(this.sliderRef, {
            spaceBetween: 24,
            navigation: {
              nextEl: this.nextRef,
              prevEl: this.previousRef,
            },
            breakpoints: {
              0: {
                slidesPerView: 1.2,
                slidesPerGroup: 1,
                spaceBetween: 10,
              },
              375: {
                slidesPerView: 2.2,
                slidesPerGroup: 2,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 4,
              },
              1280: {
                slidesPerView: this.productsToShow || 4,
                slidesPerGroup: 4,
              },
            },
            a11y: false,
          });
        }
      }
    );
  }
});
